import { computed } from '@ember/object';


function ifUndefined(fallback) {
  return computed({
    get() {
      return fallback;
    },
    set(_, v) {
      return v === undefined ? fallback : v;
    }
  });
}
export default ifUndefined;
